import { useState, useEffect, useCallback } from 'react';
import { useMedia } from 'react-use';

const useHasNotch = () => {
    const [hasNotch, setHasNotch] = useState(false);

    const matchLandscape = useMedia('(orientation: landscape)');

    const checkHasNotch = useCallback(() => {
        let proceed = false;
        let calculatedPaddingLeft = 0;
        let calculatedPaddingTop = 0;

        const newDiv = document.createElement('div');

        if (CSS.supports('padding-bottom: env(safe-area-inset-left)')) {
            newDiv.style.paddingLeft = 'env(safe-area-inset-left)';
            newDiv.style.paddingTop = 'env(safe-area-inset-top)';
            proceed = true;
        } else if (CSS.supports('padding-bottom: constant(safe-area-inset-left)')) {
            newDiv.style.paddingLeft = 'constant(safe-area-inset-left)';
            newDiv.style.paddingTop = 'constant(safe-area-inset-top)';
            proceed = true;
        }

        if (proceed) {
            document.body.appendChild(newDiv);
            calculatedPaddingLeft = parseInt(window.getComputedStyle(newDiv).paddingLeft, 10);
            calculatedPaddingTop = parseInt(window.getComputedStyle(newDiv).paddingTop, 10);
            document.body.removeChild(newDiv);
        }

        if (calculatedPaddingLeft > 0 || calculatedPaddingTop > 0) {
            return true;
        }

        return false;
    }, []);

    useEffect(() => {
        const nextHasNotch = checkHasNotch();
        setHasNotch(nextHasNotch);
    }, [matchLandscape]);

    return hasNotch;
};

export default useHasNotch;
